// Centralised content / data for Stenzia Displays website

export const BRAND = {
  name: "Stenzia Displays LLP",
  short: "Stenzia",
  wordmark: "STENZIA",
  wordmarkSub: "DISPLAYS",
  tagline: "Engineered for Display Excellence",
  email: "info@stenziadisplays.com",
  phone: "+91 97273 55516",           // Primary — Sales & Support (also WhatsApp)
  phoneSecondary: "+91 99253 55561",  // Secondary — Call button
  phoneRaw: "919727355516",           // WhatsApp digits
  callRaw: "919925355561",            // Phone-dialer digits (floating call button)
  website: "www.stenziadisplays.com",
  address: "Morbi, Gujarat, India",
  whatsappMsg:
    "Hello STENZIA Displays,\n\nI am interested in your display systems.\n\nPlease share product details, pricing and delivery information.",
};

export const NAV = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Products", path: "/products" },
  { label: "Manufacturing", path: "/manufacturing" },
  { label: "Gallery", path: "/gallery" },
  { label: "Contact", path: "/contact" },
];

import { IMAGES } from "./images";
export { IMAGES };

export const REGIONS_INTL = [
  "India", "UAE", "Saudi Arabia", "Qatar", "Oman", "Kuwait", "Bahrain",
  "Europe", "United Kingdom", "USA", "Canada", "Australia", "Singapore", "South Africa"
];

export const REGIONS_INDIA = [
  "Gujarat", "Maharashtra", "Rajasthan", "Delhi", "Haryana", "Punjab",
  "Uttar Pradesh", "Madhya Pradesh", "Karnataka", "Tamil Nadu", "Telangana",
  "Andhra Pradesh", "Kerala", "West Bengal", "Odisha", "Chhattisgarh"
];

export const CLIENT_REGIONS = [...REGIONS_INTL];

// Legacy PRODUCTS export — derived from CATEGORIES so the existing UI
// (home grid, footer links, quote form select) keeps working unchanged
// while the real, scalable product data lives in `lib/catalog.js`.
import { CATEGORIES as _CATEGORIES } from "./catalog";

export const PRODUCTS = _CATEGORIES
  .slice()
  .sort((a, b) => a.order - b.order)
  .map((c) => ({
    slug: c.slug,
    name: c.name,
    short: c.short,
    description: c.description,
    capacity: c.capacity,
    image: c.image,
    tag: c.tag,
  }));

export const FEATURES = [
  { title: "Heavy Duty Construction", body: "Heavy duty CRC steel construction with reinforced welded joints — built for continuous showroom usage.", icon: "Shield" },
  { title: "Premium Powder Coating", body: "Electrostatic 7-tank pre-treatment and premium powder coating engineered for long-lasting indoor showroom use and superior surface protection.", icon: "Sparkles" },
  { title: "Smooth Sliding System", body: "SS 202 sliding rail and SS 202 panel wheels with premium nylon top guide wheels — silent, friction-free movement.", icon: "MoveHorizontal" },
  { title: "Surface Protection", body: "Premium electrostatic powder coating delivers a uniform, durable finish — scratch and humidity resistant.", icon: "Droplets" },
  { title: "Custom Manufacturing", body: "Stand sizing, colours, branding and lighting — engineered to your exact showroom spec.", icon: "Settings2" },
  { title: "Space Saving Design", body: "Up to 4× more tiles in the same square meter vs traditional racks.", icon: "Maximize2" },
  { title: "Modern Engineering", body: "CAD-driven design, CNC fabrication and FEA load analysis on every model.", icon: "Cpu" },
];

export const INDUSTRIES = [
  { title: "Tile Manufacturers", body: "OEM display solutions for India's largest ceramic and porcelain producers." },
  { title: "Ceramic Brands", body: "Branded retail systems for global tile labels and franchise networks." },
  { title: "Showroom Owners", body: "Turnkey display fit-outs that elevate the in-store customer journey." },
  { title: "Exporters", body: "Container-ready, knock-down designs engineered for international shipping." },
  { title: "Architects & Designers", body: "Modular systems specified into hospitality, retail and residential projects." },
  { title: "Distributors & Dealers", body: "Volume pricing, fast lead times and dependable after-sales support." },
];

export const PROCESS = [
  { step: "01", title: "Design & CAD", body: "In-house engineers translate your brief into precise 3D models and CAD drawings." },
  { step: "02", title: "Laser Cutting", body: "Precision laser cutting on premium NIZONE CRC steel — micrometre tolerances." },
  { step: "03", title: "Fabrication", body: "Jig-welded chassis built to tight dimensional tolerances by certified welders." },
  { step: "04", title: "Powder Coating", body: "7-tank pre-treatment + electrostatic powder coating, cured in a climate-controlled booth." },
  { step: "05", title: "Assembly", body: "Hand-balanced sub-assemblies, alignment checks and final fitment." },
  { step: "06", title: "Quality Inspection", body: "Careful inspection during fabrication, welding, assembly, finishing and final dispatch." },
  { step: "07", title: "Dispatch", body: "Container-optimised knock-down packing and despatch to showrooms worldwide." },
];

export const TESTIMONIALS = [
  {
    quote: "Stenzia transformed our flagship showroom. Customers literally spend twice as long browsing — and our conversion has climbed with them.",
    name: "Rajesh Patel",
    role: "Director, Aurum Ceramics",
    location: "Mumbai, India",
  },
  {
    quote: "Container-ready, perfectly engineered and a finish that holds up in Dubai's climate. Stenzia is our long-term display partner.",
    name: "Khalid Al-Mansoori",
    role: "Procurement Head",
    location: "Dubai, UAE",
  },
  {
    quote: "We specified Stenzia's wall system into three luxury hospitality projects this year. Architect-grade engineering, beautifully detailed.",
    name: "Anita Mehrotra",
    role: "Principal Architect, Studio M+",
    location: "Bangalore, India",
  },
];

export const FAQS = [
  {
    q: "What is the typical lead time for a custom display stand?",
    a: "Standard models ship in 10–15 working days. Custom and large-format projects typically take 25–35 working days depending on scope.",
  },
  {
    q: "Do you export internationally?",
    a: "Yes. We have shipped to 15+ countries across the Middle East, Europe, Africa and South-East Asia. Our knock-down designs are container-optimised.",
  },
  {
    q: "Can the stands be branded with our logo and colours?",
    a: "Absolutely. Powder coating in matte black, pure white, industrial grey or custom RAL, laser-engraved logos and branded acrylic plates are all standard customisations.",
  },
  {
    q: "How is STENZIA built for long-term performance?",
    a: "Every STENZIA display is manufactured using heavy-duty CRC steel construction, premium electrostatic powder coating and careful inspection at every production stage — engineered for reliable showroom performance for many years under normal operating conditions.",
  },
  {
    q: "Do you support showroom design consulting?",
    a: "Yes. Our design team provides free showroom layouts and design support for confirmed orders.",
  },
];

export const STATS = [
  { value: "20+", label: "Years of Engineering & Manufacturing Experience" },
  { value: "51+", label: "Successfully Installed Display Systems" },
  { value: "20+", label: "Product Variants" },
  { value: "10,000+", label: "Sq. Ft. Manufacturing Facility" },
];
